var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRollback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3155",
    "data-name": "Group 3155",
    transform: "translate(-287 -43)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_239",
    "data-name": "Ellipse 239",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(287 43)",
    fill: "#f4f5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-reload",
    "data-name": "Icon open-reload",
    d: "M14.717,0A14.754,14.754,0,1,1,4.242,25.229L6.9,22.574A11.073,11.073,0,1,0,14.754,3.689,10.73,10.73,0,0,0,7.045,7.045l4.02,4.02H0V0L4.389,4.389A14.672,14.672,0,0,1,14.754,0Z",
    transform: "translate(312.464 57.503) rotate(29)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRollback);
export default __webpack_public_path__ + "static/media/rollback.a4425db34dfbdb0e5ecc9bb73089dbc2.svg";
export { ForwardRef as ReactComponent };